import validate from "/app/template1/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirects_45global from "/app/template1/middleware/redirects.global.ts";
import route_45global from "/app/template1/middleware/route.global.ts";
import manifest_45route_45rule from "/app/template1/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirects_45global,
  route_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}